export const GET_BIKE_LIST = 'GET_BIKE_LIST';

export const getBikeList = (ids) => ({
  type: GET_BIKE_LIST,
  ids,
});
